import React from 'react';
import ReactDOM from 'react-dom';
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
} from 'react-router-dom';
import { Provider } from 'react-redux';
import { ThemeProvider } from '@mui/material/styles';
import configureStore from './redux/configureStore';
import {
  Auth,
  User,
  Customer,
  Material,
  Information,
  Accounting,
  Gold,
} from './layouts';
import Home from './views/Home';
import PrivateRoute from './contexts/PrivateRoute';
import AuthProvider from './contexts/AuthContext';
import theme from './theme';

import '@fortawesome/fontawesome-free/css/all.min.css';
import './assets/styles/index.css';

const store = configureStore();
if (process.env.NODE_ENV === 'production') {
  console.log = () => {};
}

ReactDOM.render(
  <Router>
    <Provider store={store}>
      <AuthProvider>
        <ThemeProvider theme={theme}>
          <div className="bg-gray-100">
            <Switch>
              <Route path="/auth" component={Auth} />
              <PrivateRoute>
                <Route exact path="/" component={Home} />
                <Route path="/auth" component={Auth} />
                <Route path="/customer" component={Customer} />
                <Route path="/user" component={User} />
                <Route path="/material" component={Material} />
                <Route path="/information" component={Information} />
                <Route path="/accounting" component={Accounting} />
                <Route path="/gold" component={Gold} />
              </PrivateRoute>
              <Redirect from="*" to="/userss" />
            </Switch>
          </div>
        </ThemeProvider>
      </AuthProvider>
    </Provider>
  </Router>,
  document.getElementById('root'),
);
